import {map, pipe, prop} from "ramda";

const Series = ({ uuid, slug, content }) => ({
  uuid,
  slug,
  ...content,
});

const SeriesListings = pipe(prop('stories'), map(Series))

export {SeriesListings}
